
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import { ToolButton } from '../../../core';
import buttonCommandClick from './buttonCommandClick';

const ButtonCommandSetCenter = (props) => {

    const dispatch = useDispatch();
    const onClick = () => {
        buttonCommandClick(dispatch, 'SET_CENTER', {x: props.x, y: props.y});
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon('Location')}
            title="Vycentrovat"
            onClick={onClick}
        />
    );
}

export default ButtonCommandSetCenter;
